const topics = [
  {
    image: 'https://readdy.ai/api/search-image?query=Korean%20romance%20manhwa%20illustration%20style%2C%20beautiful%20couple%20in%20modern%20city%20setting%2C%20soft%20warm%20pink%20and%20coral%20tones%2C%20delicate%20art%20style%20with%20flowing%20hair%2C%20dramatic%20lighting%2C%20emotional%20atmosphere%2C%20webtoon%20cover%20art%20quality&width=800&height=500&seq=carousel-topic-01&orientation=landscape',
    tag: '热门韩漫',
    title: '2026夏季必追韩漫推荐',
    desc: '精选十部今夏最火爆的韩漫作品，画风精美剧情在线，每一部都值得熬夜追完。',
    count: '2.8万人在看',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Japanese%20shonen%20manga%20action%20scene%20illustration%2C%20dynamic%20fighting%20pose%20with%20energy%20effects%2C%20warm%20orange%20and%20amber%20color%20scheme%2C%20epic%20battle%20atmosphere%2C%20detailed%20line%20art%2C%20manga%20panel%20style%20composition&width=800&height=500&seq=carousel-topic-02&orientation=landscape',
    tag: '日漫精选',
    title: '热血日漫新番指南',
    desc: '从经典续作到黑马新番，日漫板块为你整理最值得追的热血战斗与奇幻冒险作品。',
    count: '3.1万人在看',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20fantasy%20cultivation%20illustration%2C%20ancient%20Chinese%20warrior%20in%20flowing%20robes%20with%20magical%20effects%2C%20warm%20golden%20and%20coral%20tones%2C%20mystical%20mountain%20landscape%2C%20elegant%20art%20style&width=800&height=500&seq=carousel-topic-03&orientation=landscape',
    tag: '国漫崛起',
    title: '国漫佳作盘点',
    desc: '国产漫画近年质量飞跃，精选玄幻、古风、都市类标杆作品，感受国漫的独特魅力。',
    count: '1.9万人在看',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Suspense%20thriller%20manga%20style%20illustration%2C%20dark%20mysterious%20atmosphere%20with%20dramatic%20shadows%2C%20warm%20amber%20light%20accents%2C%20noir%20comic%20art%20style%2C%20intriguing%20visual%20storytelling%20composition&width=800&height=500&seq=carousel-topic-04&orientation=landscape',
    tag: '悬疑专题',
    title: '烧脑悬疑漫精选',
    desc: '喜欢推理悬疑？这些节奏紧凑、反转惊人的漫画绝对让你欲罢不能。',
    count: '1.5万人在看',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Romantic%20comedy%20manga%20illustration%20with%20sweet%20couple%20moment%2C%20school%20life%20setting%2C%20soft%20warm%20peach%20and%20coral%20color%20palette%2C%20fluffy%20atmosphere%2C%20heartwarming%20shojo%20art%20style&width=800&height=500&seq=carousel-topic-05&orientation=landscape',
    tag: '甜宠恋爱',
    title: '甜蜜恋爱漫画合集',
    desc: '高糖预警！从校园初恋到霸道总裁，这些甜到掉牙的恋爱漫画让你全程姨母笑。',
    count: '2.3万人在看',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Fantasy%20adventure%20manga%20illustration%20with%20magical%20world%20and%20diverse%20characters%2C%20vibrant%20warm%20colors%2C%20epic%20journey%20theme%2C%20detailed%20fantasy%20landscape%2C%20adventure%20comic%20cover%20art%20style&width=800&height=500&seq=carousel-topic-06&orientation=landscape',
    tag: '奇幻冒险',
    title: '异世界奇幻冒险之旅',
    desc: '从异世界转生到奇幻大陆，精选最受欢迎的冒险类漫画，带你进入无限想象的世界。',
    count: '2.6万人在看',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-primary-100 text-primary-700 mb-4 whitespace-nowrap">
            精选专题
          </span>
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 font-heading">
            热门专题推荐
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mt-3 max-w-[600px] mx-auto">
            精心策划的漫画专题合集，帮你发现更多好作品
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {topics.map((item) => (
            <div
              key={item.title}
              className="group rounded-2xl overflow-hidden bg-background-100 border border-background-200/60 hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full text-xs font-semibold bg-accent-500 text-white">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute bottom-3 right-3">
                  <span className="px-2.5 py-1 rounded-full text-xs font-medium bg-background-950/60 text-white backdrop-blur-sm">
                    {item.count}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-base font-bold text-foreground-900 font-heading group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 mt-1.5 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}